"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badgeController = void 0;
const endpoints_1 = require("../../../constants/endpoints");
const apiPath = endpoints_1.endpoints.badge;
const badgeController = (service) => ({
    reviews: (appType, platform) => {
        return service.get(`${apiPath}/${appType}/${platform}`);
    },
    version: (appGuid) => {
        return service.get(`${apiPath}/${appGuid}`);
    }
});
exports.badgeController = badgeController;
